var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.actions)?_c('Dropdown',{attrs:{"options":_vm.actions},on:{"onClick":_vm.handleClickOption}},[_c('WButton',{attrs:{"iconLeft":"refresh-cw","outline":"","color":"accent-blue","disabled":_vm.isLoading,"loading":_vm.isLoading}},[_vm._v(" "+_vm._s(_vm.$t('entities.reloadEntities'))+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }